import { Component, EventEmitter, OnDestroy, Output, } from '@angular/core';

import { TargetingSearchService } from '../../../../../Discover/Targeting/services/targeting-search.service';
import { DiscoverRoutingService } from '../../../../../Discover/DiscoverRouter/services/discover-routing.service';
import { TargetingListService } from '../../../../../Discover/Targeting/services/targeting-list.service';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ListPickerService } from '../../../services/list-picker.service';
import { ContactsPublicApi } from '../../../../../api/targeting/contacts-public.api';
import { ResultCardDirective } from '../../../../TargetingShared/components/ResultCard/result-card.directive';
import { EntityType } from '../../../../../api/targeting/enum/entity.type.enum';
import { ContactService } from '../../../../TargetingShared/services/contact-service';
import { TargetingResultModel } from '../../../../../Discover/Targeting/models/targeting-result.model';
import { TargetingRhpContextsService } from '../../../../TargetingShared/services/targeting-rhp-contexts.service';
import { EntityTypeDefaultImageEnum } from '../../../../Misc/enums/entity-type-default-image.enum';
import { ActionKeys } from '../../../../Forms/enums/keys.enum';
import { EntityTakeoverModel } from '../../../models/entity-takeover.model';
import { ManageListDialogComponent } from '../../../../../Discover/Targeting/components/TargetingResults/ManageListDialog/manage-list-dialog.component';
import { DistributionPickerService } from '../../../services/distribution-picker.service';
import { ManageDistDialogComponent } from '../../../../../Discover/Targeting/components/TargetingResults/ManageDistDialog/manage-dist-dialog.component';


@Component({
    selector: 'agpr-entity-list-card',
    templateUrl: './entity-list-card.component.html',
    styleUrls: ['./entity-list-card.component.scss'],
    standalone: false
})
export class EntityListCardComponent extends ResultCardDirective implements OnDestroy {

    readonly entityTypes = EntityType;
    imageDefault = EntityTypeDefaultImageEnum;

    @Output() showRhpTakeOver?: EventEmitter<EntityTakeoverModel> = new EventEmitter<EntityTakeoverModel>();

    constructor(
        public targetingSearchService: TargetingSearchService,
        public targetingListService: TargetingListService,
        public listPickerService: ListPickerService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService,
        public discoverRoutingService: DiscoverRoutingService,
        public contactsPublicApi: ContactsPublicApi,
        public contactService: ContactService,
        public targetingRhpContextsService: TargetingRhpContextsService,
        public distributionPickerService: DistributionPickerService,
    ) {
        super(targetingSearchService,
            targetingListService,
            listPickerService,
            localizationService,
            coreDialogService,
            targetingRhpContextsService,
            distributionPickerService);
    }

    onCardClicked(entity: TargetingResultModel) {
        this.showRhpTakeOver.emit(<EntityTakeoverModel>{
            entityType: entity.entityType,
            contactId: entity.id,
            outletId: entity.id,
            isPrivate: entity.isPrivate
        });
    }

    onCardKeydown(event: KeyboardEvent, entityInternal: TargetingResultModel) {
        const target = event.target as HTMLElement;
        if (target.classList.contains('agpr-targetingResults-card') && (event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            this.onCardClicked(entityInternal);
        }
    }

    openManageListDialog(entity: TargetingResultModel) {
        this.coreDialogService.open(ManageListDialogComponent, {
            inputs: {
                setEntity: entity
            },
            outputs: {}
        });
    }

    openManageDistDialog(entity: TargetingResultModel) {
        this.coreDialogService.open(ManageDistDialogComponent, {
            inputs: {
                setEntity: entity
            },
            outputs: {}
        });
    }
}
